const UNRANKED = Number.MAX_SAFE_INTEGER;
const OFFICIAL_BASE = 1000000;
export function channelRanks(source) {
    var _a, _b;
    const rank = new Map();
    let i = 0;
    for (const raw of (_a = source.official) !== null && _a !== void 0 ? _a : []) {
        const id = String(raw !== null && raw !== void 0 ? raw : "").trim();
        if (!id || rank.has(id))
            continue;
        rank.set(id, OFFICIAL_BASE + i++);
    }
    let j = 0;
    for (const raw of (_b = source.premise) !== null && _b !== void 0 ? _b : []) {
        const id = String(raw !== null && raw !== void 0 ? raw : "").trim();
        if (!id)
            continue;
        if (!rank.has(id) || rank.get(id) >= OFFICIAL_BASE)
            rank.set(id, j++);
    }
    return rank;
}
export function compareChannels(a, b, rank) {
    var _a, _b, _c, _d;
    const ar = (_a = rank.get(a.id)) !== null && _a !== void 0 ? _a : UNRANKED;
    const br = (_b = rank.get(b.id)) !== null && _b !== void 0 ? _b : UNRANKED;
    if (ar !== br)
        return ar - br;
    const araw = (_c = (a.title || a.id)) !== null && _c !== void 0 ? _c : "";
    const braw = (_d = (b.title || b.id)) !== null && _d !== void 0 ? _d : "";
    const ak = araw.toLowerCase();
    const bk = braw.toLowerCase();
    if (ak !== bk)
        return ak < bk ? -1 : 1;
    if (araw !== braw)
        return araw < braw ? -1 : 1;
    if (a.id === b.id)
        return 0;
    return a.id < b.id ? -1 : 1;
}
export function orderChannels(channels, read, source) {
    const rank = channelRanks(source);
    return [...channels].sort((a, b) => compareChannels(read(a), read(b), rank));
}
